<template>
  <div class="text-xs-left">
    <br />
    <hr />
    <hr />

    <div v-for="(l,li) in lista" class="ma-2 white" :key="li">
      <h2>{{T(l.modulo.mod_titulo)}} - {{T(l.modulo.mod_secaomen)}} - {{T(l.modulo.mod_acao_add)}}</h2>
      <ul>
        <li v-for="(c,ci) in l.campos" :key="ci">{{T(c.cmp_titulo)}} - {{T(c.cmp_dica)}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
try{
  var _base = require("@/page/_base.vue").default;
}catch(err){
  var _base = require("@/framework/page/_base.vue").default;
}


export default {
  extends: _base,

  data() {
    return { global, lista: [] };
  },

  mounted() {
    for (let d in global.dbdef) {
      this.lista.push(global.dbdef[d]);
    }
  },

  methods: {},
};
</script>

